import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetifyPlugin from './plugins/vuetify.js'

const app = createApp(App)

app.use(router)
app.use(store)
app.use(vuetifyPlugin)

app.mount('#app')
